import BannerSlider from "@/src/components/HomePage/BannerSlider/BannerSlider";
import UniversityPrograms from "@/src/components/HomePage/UniversityPrograms/UniversityPrograms";
import WhyChoose from "@/src/components/HomePage/WhyChoose/WhyChoose";
import AdmissionProcess from "@/src/components/HomePage/AdmimssionProcess/AdmissionProcess";
import DigitalUniversity from "@/src/components/HomePage/DigitalUniversity/DigitalUniversity";

const HomePage = () => {
  return (
    <div className="home-page">
      <BannerSlider />
      <UniversityPrograms />
      <WhyChoose />
      <AdmissionProcess />
      <DigitalUniversity />
    </div>
  );
};

export default HomePage;
